import {
  TFilterSelected,
  TMachineDetails,
  TREQUEST_BULK_ASSIGN_LOCATIONS,
  TREQUEST_DELETE_MACHINE,
  TREQUEST_BULK_UPDATE_STATUS,
  TREQUEST_MACHINE_TRANSFER,
  TRESPONSE_GET_BULK_ASSIGN_LOCATIONS_DROPDOWN,
  TRESPONSE_GET_MACHINE_AND_LINE_DETAILS,
  TRESPONSE_MACHINE_LIST,
  TRESPONSE_MACHINE_TRANSFER_DROPDOWN,
  TRESPONSE_UPDATE_MACHINE_FIELD_DROPDOWN,
  TListingFetchReason,
  TREQUEST_BULK_UPDATE_PRINTED_STATUS,
  TRESPONSE_GET_SIBLING_FACTORIES_DROPDOWN,
  TREQUEST_TRANSFER_MACHINE_TO_SIBLING_FACTORY,
  TREQUEST_BULK_UPDATE_PREVENTIVE_SCHEDULE,
  TMachineListingTab,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';
import { TMachineListInfoActionType } from './machine-list.models';

export class GetMachineListInfo implements Action {
  readonly type = TMachineListInfoActionType.GetMachineList;
  constructor(
    public fetchReason: TListingFetchReason,
    public selectedFilters: TFilterSelected[],
    public searchStrOpt?: string,
  ) {}
}
export class GetMachineListInfoSuccess implements Action {
  readonly type = TMachineListInfoActionType.GetMachineListSuccess;
  constructor(public machineListRes: TRESPONSE_MACHINE_LIST, public fetchReason: TListingFetchReason) {}
}

export class GetMachineListInfoFailure implements Action {
  readonly type = TMachineListInfoActionType.GetMachineListFailure;
}

export class SetMachineListPagination implements Action {
  readonly type = TMachineListInfoActionType.SetMachineListPagination;
  constructor(public pagination: TUserPaginationOption) {}
}

export class GetMachineListFilterDropDownInfo implements Action {
  readonly type = TMachineListInfoActionType.GetMachineListFilterDropDown;
}

export class GetMachineListFilterDropDownInfoSuccess implements Action {
  readonly type = TMachineListInfoActionType.GetMachineListFilterDropDownSuccess;
  constructor(public machineListDropdownRes: TRESPONSE_UPDATE_MACHINE_FIELD_DROPDOWN) {}
}

export class GetMachineListFilterDropDownInfoFailure implements Action {
  readonly type = TMachineListInfoActionType.GetMachineListFilterDropDownFailure;
}

export class DeleteMachines implements Action {
  readonly type = TMachineListInfoActionType.DeleteMachines;
  constructor(public factorySerialNumbers: TREQUEST_DELETE_MACHINE['factorySerialNumbers']) {}
}

export class DeleteMachinesSuccess implements Action {
  readonly type = TMachineListInfoActionType.DeleteMachinesSuccess;
}

export class DeleteMachinesFailure implements Action {
  readonly type = TMachineListInfoActionType.DeleteMachinesFailure;
}

export class BulkUpdateStatus implements Action {
  readonly type = TMachineListInfoActionType.BulkUpdateStatus;
  constructor(public payload: TREQUEST_BULK_UPDATE_STATUS) {}
}

export class BulkUpdateStatusSuccess implements Action {
  readonly type = TMachineListInfoActionType.BulkUpdateStatusSuccess;
}

export class BulkUpdateStatusFailure implements Action {
  readonly type = TMachineListInfoActionType.BulkUpdateStatusFailure;
}

export class BulkUpdatePrintedStatus implements Action {
  readonly type = TMachineListInfoActionType.BulkUpdatePrintedStatus;
  constructor(public payload: TREQUEST_BULK_UPDATE_PRINTED_STATUS) {}
}

export class BulkUpdatePrintedStatusSuccess implements Action {
  readonly type = TMachineListInfoActionType.BulkUpdatePrintedStatusSuccess;
}

export class BulkUpdatePrintedStatusFailure implements Action {
  readonly type = TMachineListInfoActionType.BulkUpdatePrintedStatusFailure;
}

export class GetBulkAssignLocationDropdown implements Action {
  readonly type = TMachineListInfoActionType.GetBulkAssignLocationDropdown;
}

export class GetBulkAssignLocationDropdownSuccess implements Action {
  readonly type = TMachineListInfoActionType.GetBulkAssignLocationDropdownSuccess;
  constructor(public res: TRESPONSE_GET_BULK_ASSIGN_LOCATIONS_DROPDOWN) {}
}

export class GetBulkAssignLocationDropdownFailure implements Action {
  readonly type = TMachineListInfoActionType.GetBulkAssignLocationDropdownFailure;
}

export class GetSiblingFactoriesDropdown implements Action {
  readonly type = TMachineListInfoActionType.GetSiblingFactoriesDropdown;
}

export class GetSiblingFactoriesDropdownSuccess implements Action {
  readonly type = TMachineListInfoActionType.GetSiblingFactoriesDropdownSuccess;
  constructor(public res: TRESPONSE_GET_SIBLING_FACTORIES_DROPDOWN) {}
}

export class GetSiblingFactoriesDropdownFailure implements Action {
  readonly type = TMachineListInfoActionType.GetSiblingFactoriesDropdownFailure;
}

export class TransferToSiblingFactory implements Action {
  readonly type = TMachineListInfoActionType.TransferToSiblingFactory;
  constructor(public payload: TREQUEST_TRANSFER_MACHINE_TO_SIBLING_FACTORY) {}
}

export class TransferToSiblingFactorySuccess implements Action {
  readonly type = TMachineListInfoActionType.TransferToSiblingFactorySuccess;
}

export class TransferToSiblingFactoryFailure implements Action {
  readonly type = TMachineListInfoActionType.TransferToSiblingFactoryFailure;
}

export class BulkUpdatePreventiveSchedule implements Action {
  readonly type = TMachineListInfoActionType.BulkUpdatePreventiveSchedule;
  constructor(public payload: TREQUEST_BULK_UPDATE_PREVENTIVE_SCHEDULE) {}
}

export class BulkUpdatePreventiveScheduleSuccess implements Action {
  readonly type = TMachineListInfoActionType.BulkUpdatePreventiveScheduleSuccess;
}
export class BulkUpdatePreventiveScheduleFailure implements Action {
  readonly type = TMachineListInfoActionType.BulkUpdatePreventiveScheduleFailure;
}

export class BulkAssignLocation implements Action {
  readonly type = TMachineListInfoActionType.AssignBulkLocation;
  constructor(public payload: Omit<TREQUEST_BULK_ASSIGN_LOCATIONS, 'factoryId'>) {}
}

export class BulkAssignLocationSuccess implements Action {
  readonly type = TMachineListInfoActionType.AssignBulkLocationSuccess;
}

export class BulkAssignLocationFailure implements Action {
  readonly type = TMachineListInfoActionType.AssignBulkLocationFailure;
}

export class MachineTransferDropdown implements Action {
  readonly type = TMachineListInfoActionType.GetMachineTransferDropdown;
  constructor(public factorySerialNumber: TMachineDetails['factorySerialNumber']) {}
}

export class MachineTransferDropdownSuccess implements Action {
  readonly type = TMachineListInfoActionType.GetMachineTransferDropdownSuccess;
  constructor(public res: TRESPONSE_MACHINE_TRANSFER_DROPDOWN) {}
}

export class MachineTransferDropdownFailure implements Action {
  readonly type = TMachineListInfoActionType.GetMachineTransferDropdownFailure;
}

export class MachineTransfer implements Action {
  readonly type = TMachineListInfoActionType.MachineTransfer;
  constructor(public payload: Omit<TREQUEST_MACHINE_TRANSFER, 'factoryId'>) {}
}

export class MachineTransferSuccess implements Action {
  readonly type = TMachineListInfoActionType.MachineTransferSuccess;
}

export class MachineTransferFailure implements Action {
  readonly type = TMachineListInfoActionType.MachineTransferFailure;
}

export class ResetMachineAndLineDetails implements Action {
  readonly type = TMachineListInfoActionType.ResetMachineAndLineDetails;
}

export class GetMachineAndLineDetails implements Action {
  readonly type = TMachineListInfoActionType.GetMachineAndLineDetails;
  constructor(
    public factorySerialNumber: TRESPONSE_MACHINE_LIST['machines'][number]['machine']['factorySerialNumber'],
  ) {}
}

export class GetMachineAndLineDetailsSuccess implements Action {
  readonly type = TMachineListInfoActionType.GetMachineAndLineDetailsSuccess;
  constructor(public res: TRESPONSE_GET_MACHINE_AND_LINE_DETAILS) {}
}

export class GetMachineAndLineDetailsFailure implements Action {
  readonly type = TMachineListInfoActionType.GetMachineAndLineDetailsFailure;
}

export class SetMachineListingTab implements Action {
  readonly type = TMachineListInfoActionType.SetMachineListingTab;
  constructor(public tab: TMachineListingTab) {}
}

export type TMachineListActions =
  | SetMachineListPagination
  | GetMachineListInfo
  | GetMachineListInfoSuccess
  | GetMachineListInfoFailure
  | GetMachineListFilterDropDownInfo
  | GetMachineListFilterDropDownInfoSuccess
  | GetMachineListFilterDropDownInfoFailure
  | DeleteMachines
  | DeleteMachinesSuccess
  | DeleteMachinesFailure
  | BulkUpdateStatus
  | BulkUpdateStatusSuccess
  | BulkUpdateStatusFailure
  | BulkUpdatePrintedStatus
  | BulkUpdatePrintedStatusSuccess
  | BulkUpdatePrintedStatusFailure
  | GetBulkAssignLocationDropdown
  | GetBulkAssignLocationDropdownSuccess
  | GetBulkAssignLocationDropdownFailure
  | BulkAssignLocation
  | BulkAssignLocationSuccess
  | BulkAssignLocationFailure
  | MachineTransfer
  | MachineTransferSuccess
  | MachineTransferFailure
  | MachineTransferDropdown
  | MachineTransferDropdownSuccess
  | MachineTransferDropdownFailure
  | ResetMachineAndLineDetails
  | GetMachineAndLineDetails
  | GetMachineAndLineDetailsSuccess
  | GetMachineAndLineDetailsFailure
  | GetSiblingFactoriesDropdown
  | GetSiblingFactoriesDropdownSuccess
  | GetSiblingFactoriesDropdownFailure
  | TransferToSiblingFactory
  | TransferToSiblingFactorySuccess
  | TransferToSiblingFactoryFailure
  | SetMachineListingTab;
